import { Icon } from "@iconify/react";
import React from "react";
import { Col, Container, Row } from "reactstrap";
import { useLanguage } from "../../../context/LanguageContext";

const Features = () => {
  const { language } = useLanguage();
  const translatedFeatures = {
    pt: {
      features: [
        {
          id: 1,
          featureIcon: "uim-object-ungroup",
          featureName: "Gestão de Anúncios de Vagas",
        },
        {
          id: 2,
          featureIcon: "uim-telegram-alt",
          featureName: "Criação e Gestão de CVs",
        },
        {
          id: 3,
          featureIcon: "uim-lock-access",
          featureName: "Privacidade e Segurança de Dados",
        },
        {
          id: 4,
          featureIcon: "uim-airplay",
          featureName: "Exibição Transparente de Oportunidades",
        },
        {
          id: 5,
          featureIcon: "uim-history",
          featureName: "Suporte Técnico Rápido",
        },
      ],
    },
    en: {
      features: [
        {
          id: 1,
          featureIcon: "uim-object-ungroup",
          featureName: "Job Posting Management",
        },
        {
          id: 2,
          featureIcon: "uim-telegram-alt",
          featureName: "CV Creation and Management",
        },
        {
          id: 3,
          featureIcon: "uim-lock-access",
          featureName: "Data Privacy & Security",
        },
        {
          id: 4,
          featureIcon: "uim-airplay",
          featureName: "Transparent Job Display",
        },
        {
          id: 5,
          featureIcon: "uim-history",
          featureName: "Fast Technical Support",
        },
      ],
    },
  };

  const t = translatedFeatures[language] || translatedFeatures["pt"];
  return (
    <React.Fragment>
      <section className="section bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7}>
              <div className="section-title text-center mb-5">
                <h3 className="title mb-4">
                  {language === "pt"
                    ? "Principais Funcionalidades"
                    : "Main Features"}
                </h3>
                <p className="para-desc text-muted mx-auto">
                  {language === "pt"
                    ? "Descubra as funcionalidades da nossa plataforma que tornam o processo de recrutamento, gestão e conexão com talentos mais simples e eficiente."
                    : "Discover the features of our platform that make recruitment, management, and connecting with talent simpler and more efficient."}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            {t.features.map((featuresDetails, key) => (
              <Col lg={4} md={6} className="mt-4 pt-2" key={key}>
                <div className="about-feature p-3 d-flex align-items-center rounded-3">
                  <div className="featrue-icon flex-shrink-0">
                    <Icon
                      icon={featuresDetails.featureIcon}
                      className="text-primary"
                    />
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h6 className="fs-18 mb-0">
                      {featuresDetails.featureName}
                    </h6>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Features;
